import { ComponentStoreV2Factory } from '../../../../shared/store/common/component-store-v2.factory';
import { computed, Injectable } from '@angular/core';
import { globalStore } from '../../../../shared/shared.global-service';
import { toSignal } from '@angular/core/rxjs-interop';
import { selectFolderId } from '../../../store/person/person.selectors';
import { FolderPalliativeCareObject } from '@libs/types/src/services/object-type/folder/folder-palliative-care.object';

@Injectable()
export class PersonPalliativeCareStore extends ComponentStoreV2Factory {

    public folderId = toSignal(globalStore!.select(selectFolderId));
    public items = computed<FolderPalliativeCareObject[]>(() => this.data.getFolderPalliativeCares()?.items || []);

}
